module.exports = __webpack_public_path__ + "static/media/(V)_MG_6040_-_Cia_Termal_Beachewear_-_Moda_Feminina_Infantil.46119f48.jpg";